import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { Typography, Card } from 'antd';
// import PromotionForm from '../components/promotions/PromotionForm';
import promotionApiService, {
  CreatePromotionRequest,
} from '../services/promotionApiService';
import { Promotion } from '../types/promotions';
import PromotionForm from '../components/promotions/PromotionForm';

const { Title, Text } = Typography;

const PromotionCreate: React.FC = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  // Xử lý khi submit form
  const handleSubmit = async (
    data: Omit<Promotion, 'id' | 'currentUsage' | 'createdAt' | 'updatedAt'>
  ) => {
    setIsSubmitting(true);
    try {
      // Convert from Promotion to CreatePromotionRequest format
      const apiData: CreatePromotionRequest = {
        code: data.code || '',
        name: data.name,
        description: data.description || '',
        type: data.discountType,
        value: data.discountValue,
        time_constraints: {
          start_date:
            typeof data.startDate === 'string'
              ? data.startDate
              : new Date(data.startDate).toISOString(),
          end_date:
            typeof data.endDate === 'string'
              ? data.endDate
              : new Date(data.endDate).toISOString(),
        },
        status: data.isActive ? 'active' : 'inactive',
        quantity: {
          total: data.usageLimit || 100,
          used: 0,
        },
        constraints: {
          minimum_order_amount: data.minOrderValue || 0,
          maximum_discount_amount: data.maxDiscountValue || null,
        },
      };

      await promotionApiService.createPromotion(apiData);
      // Chuyển hướng về trang danh sách khuyến mãi sau khi tạo thành công
      navigate('/admin/promotions');
    } catch (error) {
      console.error('Error creating promotion:', error);
      setIsSubmitting(false);
      throw error;
    }
  };

  // Xử lý khi hủy
  const handleCancel = () => {
    navigate('/admin/promotions');
  };

  return (
    <div className='p-6'>
      <div className='mb-6'>
        <Link
          to='/admin/promotions'
          className='inline-flex items-center text-blue-600 hover:text-blue-800'
        >
          <ArrowLeftOutlined className='h-4 w-4 mr-1' />
          <span>Quay lại danh sách khuyến mãi</span>
        </Link>
        <Title level={2} className='mt-4'>
          Thêm khuyến mãi mới
        </Title>
        <Text type='secondary'>
          Tạo mã khuyến mãi mới cho cửa hàng của bạn.
        </Text>
      </div>

      <Card>
        <PromotionForm
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          isSubmitting={isSubmitting}
        />
      </Card>
    </div>
  );
};

export default PromotionCreate;
